<template>
  <div v-if="!hide">
    <b-card>
      <apex-chart type="bar" height="350" :options="chartOptions" :series="series"
        v-if="chartOptions.xaxis.categories && this.series[0].data"></apex-chart>
      <b-spinner label="Loading..." v-else></b-spinner>
    </b-card>


  </div>
</template>

<script>
import ApexChart from "vue-apexcharts";
import EsepService from "../../services/esep.service";
import { handleApiError } from "../../services/error.service";

export default {
  components: {
    ApexChart
  },
  mounted() {
    this.getRequirementVersion();
  },
  watch:{
    branch(newBranch) {
      this.selectedBranch = newBranch;
      this.getAchievementProgress();
    },
    unitId(newUnitId) {
      this.selectedUnitId = newUnitId;
      this.getAchievementProgress();
    }
  },
  props: {
    branch: String,
    unitId: Number
  },
  data() {
    return {
      selectedBranch: 'CUB',
      selectedUnitId: this.unitId || Number(this.$store.state.globalUnitId) || this.$store.state.userInfo.orgMember.orgUnit.id,
      reqVersions: {},
      hide: false,
      componentKey: 0,
      branches: [
        { value: null, text: this.$t('branchEnums.null'), disabled: true },
        { value: 'CUB', text: this.$t('branchEnums.CUB') },
        { value: 'SCOUT', text: this.$t('branchEnums.SCOUT') },
        { value: 'VENTURE', text: this.$t('branchEnums.VENTURE') },
        { value: 'ROVER', text: this.$t('branchEnums.ROVER') },
      ],
      series: [
        {
          name: this.$t('branchMemberSingular.' + this.selectedBranch),
          data: null
        }
      ],
      chartOptions: {
        title: {
          text: this.$t(`branchProgress.` + this.selectedBranch),
          align: 'left'
        },
        chart: {
          height: 350,
          type: 'bar'
        },
        // colors: ['#ffd700','#006400','#8b0000','#add8e6'],
        plotOptions: {
          bar: {
            columnWidth: '45%',
            distributed: true,
          }
        },
        dataLabels: {
          enabled: false
        },
        legend: {
          show: false
        },
        xaxis: {
          categories: null,
          labels: {
            style: {
              fontSize: '12px'
            }
          }
        }
      }
    }
  },
  methods: {
    getRequirementVersion() {
      EsepService.getRequirementVersion().then(
        (response) => {
          response.data.forEach(row => {
            this.reqVersions[row.branch] = row.id;
          })
          this.getAchievementProgress();
        },
        (error) => {
          if ([4, 5].includes(Math.floor(error.response.status / 100))) {
            this.$emit('show-comp', { name: 'achievements', value: false });
          } else {
            let errorMessage = handleApiError(error);
            this.$emit('error:api', errorMessage);
          }
        }
      )
    },
    getAchievementProgress() {
      this.chartOptions.xaxis.categories = null;
      this.series[0].data = null;
      console.error("AAAAAAAAAAAAAAAAAAa")
      EsepService.getAchievementProgress(this.selectedUnitId, this.reqVersions[this.selectedBranch], ['PROGRESS_STAGE']).then(
        (response) => {
          this.series[0].name = this.$t('branchMemberSingular.' + this.selectedBranch);
          this.chartOptions.title.text = this.$t(`branchProgress.` + this.selectedBranch);
          let categories = [];
          let data = [];
          response.data.forEach(AP => {
            categories.push(AP.requirement.title);
            data.push(AP.completed);
          });

          this.chartOptions.xaxis.categories = categories;
          this.series[0].data = data;
          this.$emit('show-comp', { name: 'achievements', value: true });
        },
        (error) => {
          if ([4, 5].includes(Math.floor(error.response.status / 100))) {
            this.$emit('show-comp', { name: 'achievements', value: false });
          } else {
            let errorMessage = handleApiError(error);
            this.$emit('error:api', errorMessage);
          }
        }
      )
    }
  }
}
</script>